import React from 'react';

const WhyChooseUs = () => {
    const features = [
        {
            id: "01",
            title: "INTERVENTO UNICO",
            description: "Non coordiniamo artigiani sparsi. Siamo l'unica entità operativa in cantiere. Dalla rimozione amianto alla posa del fotovoltaico.",
        },
        {
            id: "02",
            title: "GARANZIA DECENNALE",
            description: "I nostri sistemi di copertura sono ingegnerizzati per superare i carichi neve e vento standard. Rilasciamo garanzie postume reali.",
        },
        {
            id: "03",
            title: "ASSET ENERGETICO",
            description: "Il tetto non è più solo una protezione, è una macchina da soldi. Progettiamo l'involucro per massimizzare la resa fotovoltaica.",
        }
    ];

    return (
        <section className="relative bg-white text-black py-0 overflow-hidden">

            {/* Layout a due colonne */}
            <div className="flex flex-col lg:flex-row">

                {/* COLONNA SINISTRA (Nera - Sticky) */}
                <div className="lg:w-5/12 bg-black text-white pl-8 md:pl-16 lg:pl-80 pr-8 py-12 sticky top-0 flex flex-col justify-center z-10 lg:h-auto">
                    <div>
                        <h2 className="text-4xl md:text-6xl font-bold leading-[0.9] tracking-tighter mb-8">
                            Perché <br />
                            Scegliere <br />
                            Ader.
                        </h2>

                        <p className="text-gray-400 text-lg md:text-xl font-light leading-relaxed max-w-sm border-l-2 border-white/20 pl-6">
                            Rigore tecnico e controllo totale della filiera. Costruiamo certezze, non solo tetti.
                        </p>
                    </div>
                </div>

                {/* COLONNA DESTRA (Bianca - Lista Tecnica) */}
                <div className="lg:w-7/12 bg-gray-100 px-8 md:px-16 py-12 flex flex-col justify-center">
                    <div className="max-w-2xl">

                        {features.map((item, index) => (
                            <div
                                key={index}
                                className="group relative border-b-2 border-gray-300 py-8 last:border-b-0 hover:border-black transition-colors duration-300"
                            >
                                {/* Numero Gigante "Stampato" */}
                                <div className="absolute -top-4 left-0 text-8xl font-bold text-gray-200 -z-10 group-hover:text-gray-300 transition-colors select-none font-mono opacity-50">
                                    {item.id}
                                </div>

                                <div className="relative z-10 pl-4">
                                    <h3 className="text-2xl font-bold uppercase tracking-tight mb-3">
                                        {item.title}
                                    </h3>

                                    <p className="text-gray-600 text-lg leading-relaxed max-w-lg">
                                        {item.description}
                                    </p>

                                    {/* Indicatore visivo di selezione */}
                                    <div className="mt-4 w-0 group-hover:w-12 h-1 bg-black transition-all duration-300"></div>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>

            </div>
        </section>
    );
};

export default WhyChooseUs;
